import { UpdateEstateInsightsBundleConfigurationInput } from '@/types/schema';

import { diffUnordered } from '../diff/diffUnordered';
import { BundleSaveDescriptor } from '../presentationSave.types';
import { createFlatConfigDescriptor } from './flatConfigDescriptor';

/**
 * The estate insights bundle: the missing-documents page toggle, plus the set
 * of household insights the bundle is linked to. The linked set is the
 * selection: an insight is in the bundle only when it is linked.
 *
 * The insights themselves are not this bundle's to write. The settings modal
 * assigns the household's whole insight list, and each insight is owned by the
 * insights module, so only the link is diffed here.
 */
export const estateInsightsBundleDescriptor: BundleSaveDescriptor =
  createFlatConfigDescriptor({
    field: 'estateInsightsBundleConfiguration',
    read: (bundle) => bundle.estateInsightsBundleConfiguration,
    diff: (previous, next) => {
      const update: UpdateEstateInsightsBundleConfigurationInput = {};

      if (
        previous.includeMissingDocumentsPage !==
        next.includeMissingDocumentsPage
      ) {
        update.includeMissingDocumentsPage = next.includeMissingDocumentsPage;
      }

      const insights = diffUnordered(
        previous.estateInsights.map((insight) => insight.id),
        next.estateInsights.map((insight) => insight.id)
      );
      if (insights) {
        if (insights.addIDs.length > 0) {
          update.addEstateInsightIDs = insights.addIDs;
        }
        if (insights.removeIDs.length > 0) {
          update.removeEstateInsightIDs = insights.removeIDs;
        }
      }

      // `displayName` is deliberately absent: this configuration has no
      // display-name field on the form, and the create path sends none either.
      return Object.keys(update).length > 0 ? update : null;
    },
    toPayload: (id, update) => ({
      updateEstateInsightsBundleConfiguration: { id, update },
    }),
  });
